var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x8E Icon=Box, Stroke=1.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.08925L3.5 7.06425V16.9845L12 20.3845L20.5 16.9845V7.06425L12 4.08925ZM12.3304 2.61565C12.1165 2.5408 11.8835 2.5408 11.6696 2.61565L2.66965 5.76565C2.26856 5.90603 2 6.28457 2 6.70951V17.323C2 17.7319 2.24895 18.0996 2.62861 18.2515L11.6286 21.8515C11.867 21.9468 12.133 21.9468 12.3714 21.8515L21.3714 18.2515C21.751 18.0996 22 17.7319 22 17.323V6.70951C22 6.28457 21.7314 5.90603 21.3304 5.76565L12.3304 2.61565Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72817 7.19903L3.27183 5.80102L12 9.19531L20.7282 5.80102L21.2718 7.19903L12 10.8047L2.72817 7.19903Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0611 4.03444L17.25 7.48028V10.5C17.25 10.9142 16.9142 11.25 16.5 11.25C16.0858 11.25 15.75 10.9142 15.75 10.5V8.51978L7.53441 5.43893L8.0611 4.03444Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 20.5V10H12.75V20.5H11.25Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7215C5 10.3724 5.34869 10.1308 5.67556 10.2534L8.67556 11.3784C8.87071 11.4515 9 11.6381 9 11.8465V15.2785C9 15.6276 8.65131 15.8693 8.32444 15.7467L5.32444 14.6217C5.12929 14.5485 5 14.3619 5 14.1535V10.7215Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.83edad0520d82b10807d6a5851dca1e6.svg";
export { ForwardRef as ReactComponent };